import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

export abstract class BaseApi {
  protected _client!: HttpClient;
  protected baseUrl: string = environment['apiUrl']
  protected HTTP_OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  protected HTTP_OPTIONS_RETURN_STRING: object = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }),
    responseType: 'text'
  };

   

  protected getApiUrl(apiFunction: string) {
    return this.baseUrl + apiFunction;
  }
}
